// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"853603c6","534":"2f607419","548":"4cd002ab","685":"de5f6a0b","717":"810693aa","725":"737bbf60","749":"4d2f720b","903":"0fe7e298","959":"20cb500b","974":"f51212ae"}[chunkId] + ".chunk.js";
};